<template>
  <div class="h-0 border border-brand-bgdivider-10"></div>

  <div class="flex-col justify-start items-center gap-2 inline-flex">
    <Avatar :user="referrer" />
    <div class="self-stretch text-center text-white text-sm font-sans">
      {{
        $t("channel.referral.invitation.message", {
          username: referrer.username,
        })
      }}
    </div>
  </div>

  <div class="h-0 border border-brand-bgdivider-10"></div>
</template>

<script setup lang="ts">
import Avatar from "@/components/me/avatar.vue";
import type { User } from "@/generated/graphql";

defineProps<{
  referrer: User;
}>();
</script>
